import React from 'react';
import { Image, ScrollView, View } from 'react-native';
import { Android, getSubCategoryId } from '../../../../../utils/DictionaryManagementUtils';
import {
  img_receipt,
  img_screen_paste_receipt_chat,
  img_screen_success_receipt,
} from '../../../../../utils/ImagesManagementUtils';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import SquareWithTextMessage from '../../../AuxiliaryComponent/MessageComponent/SquareWithTextMessage';
import ShareIconNearBtn from '../../../AuxiliaryComponent/MixComponent/ShareIconNearBtn';
import FullPageSimulator from '../../FullPageSimulator';

//= ========================================================================
const TransferSuccessViewReciptFP = ({
  topTitle,
  globJSON,
  selectedScreen,
  simPlatform,
  disableBtn,
  shortBtn,
  isAllieChat,
  withCopiedMessage,
  whitmansChat,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { colors } = globJSON.configurations.theme;
  const { success } = globJSON.configurations.services[subCategoryId];
  const { app_background_color } = colors;

  const myStyles = {
    receipt: {
      width: 214,
      height: simPlatform === Android ? 410 : 410,
      alignSelf: 'center',
    },
    scrollViewStyle: {
      width: 220,
      marginLeft: 10,
      flexDirection: 'column',
      backgroundColor: app_background_color,
    },
    CopiedNowMessageStyle: {
      width: '100%',
      marginTop: '26%',
      position: 'absolute',
    },
    ShareButton: {
      height: 40,
      width: 240,
      marginTop: 1,
      marginLeft: 0,
      position: 'absolute',
      bottom: 0,
      backgroundColor: app_background_color,
      boxShadow: '0 0 6px 0 rgba(0, 109, 199, 0.22)',
      paddingVertical: 5.5,
      paddingHorizontal: 17.5,
      gap: 8,
    },
  };
  const getBackgroundImageWhitmansChat = whitmansChat && img_screen_paste_receipt_chat;
  const getBackgroundImageIsAllieChat = isAllieChat && img_screen_success_receipt;

  //= ====================================================================
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={topTitle}
      WithImageBackground={simPlatform === Android ? getBackgroundImageWhitmansChat : getBackgroundImageIsAllieChat}
      headlineText={success.your_receipt}
      floatingChildren={(
        <View>
          {shortBtn && simPlatform !== Android
            ? (
              <View style={myStyles.ShareButton}>
                <LargeBtnWithFilling
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  subCategoryId={subCategoryId}
                  inputText={success.share}
                  shortBtn
                  disableBtn={disableBtn}
                />
              </View>
            ) : (
              <View style={myStyles.ShareButton}>
                <ShareIconNearBtn
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  subCategoryId={subCategoryId}
                  inputText={success.share_in_chat}
                  shortBtn
                  disableBtn={disableBtn}
                />
              </View>
            )}
        </View>
      )}
      slideshowRefs={slideshowRefs}
    >
      <ScrollView
        style={myStyles.scrollViewStyle}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        <Image
          fadeDuration={0}
          style={myStyles.receipt}
          source={img_receipt}
        />
      </ScrollView>

      {simPlatform !== Android && withCopiedMessage && (
        <View style={myStyles.CopiedNowMessageStyle}>
          <SquareWithTextMessage
            globJSON={globJSON}
            simPlatform={simPlatform}
            text={success.copied_now_paste_to_chat}
          />
        </View>
      )}
    </FullPageSimulator>

  );
};

export default TransferSuccessViewReciptFP;
